<template>
  <div class="login-container">
    <div class="title">
      <img src="@/assets/icon-green.jpg" alt="">
      <div class="login-title">登录</div>
    </div>
    <div class="submit-form">
      <van-form @submit="onSubmit">
        <van-cell-group inset>
          <van-field
            v-model="username"
            name="用户名"
            label=""
            placeholder="用户名"
            :rules="[{ required: true, message: '请填写用户名' }]"
            left-icon="phone-o"
          >

          </van-field>

          <van-field
            v-model="password"
            type="password"
            name="密码"
            label=""
            placeholder="密码"
            :rules="[{ required: true, message: '请填写密码' }]"
            left-icon="lock"
          />
        </van-cell-group>
        <div style="margin: 16px;">
          <van-button class="submit-login" block type="primary" native-type="submit">
            登录
          </van-button>
        </div>
      </van-form>
    </div>
    <div class="login-footer">
      <div @click="goTo('/forgot')">忘记密码？</div>
      <div @click="goTo('/register')">注册新账号</div>
    </div>
  </div>
</template>
<script>
import CryptoJS from 'crypto-js'
export default {
  data() {
    return {
      username: '',
      password: '',
      mob:'1'
    };
  },
  methods: {
      onSubmit(values) {
        // alert(222)
        var _this = this
        let pwd = CryptoJS.MD5(_this.password).toString(CryptoJS.enc.Hex).toLowerCase()
        // alert(pwd)
        let data = {tel:this.username,afcode:pwd,mob:"1",fchannel:localStorage.getItem('ch_id')}
        this.$api.post('login_auth',data,res=>{
            if(res.data && res.data.code == '0'  ){
              var showLoading = null;
              showLoading = this.$toast.loading({
                message: "登录中...",
                forbidClick: true,
                loadingType: "spinner",
              });
              localStorage.setItem('t',res.data.info.tk)
              localStorage.setItem('userinfo',JSON.stringify(res.data.info.info))
              setTimeout(()=>{
                _this.$router.push('/show');
              },2000)
              showLoading.close();
            }else{
             _this.$message.error(res.data.msg)
            }
          showLoading.close();
        })
    },
    goTo(path){
      this.$router.push(path);
    }
  },
};
</script>
<style scoped>
.login-container{
  height: 100vh;
  background-color: #f6f6f6
}

.login-container .title{
  font-size: 4.8vw;
  text-align: center;
  padding-top: 20vw
}

.login-container .title img {
  width: 26.666667vw;
  height: 26.666667vw;
  border-radius: 2.666667vw
}

.login-container .title .login-title{
  font-size: 6.133333vw;
  font-weight: 800
}

.login-container .submit-form .submit-login{
  background-color: #2468f2;
  border-radius: .666667vw;
  border: none
}
.login-container .login-footer{
  display: flex;
  font-size: 3.733333vw;
  justify-content: space-around
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue